
import React, { useEffect, useRef, useState } from "react";
import "../css/main.css";

const AudioDescriptionEdit = ({ videoRef, videoSrc, video}) => {
  const timelineCanvasRef = useRef(null);
  const rafRef = useRef(null);

  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [playheadPercent, setPlayheadPercent] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
const [showAddModal, setShowAddModal] = useState(false);
const [addStart, setAddStart] = useState("");
const [addEnd, setAddEnd] = useState("");
const [addText, setAddText] = useState("");
const [isAdding, setIsAdding] = useState(false);
const [toast, setToast] = useState({
  show: false,
  message: "",
  variant: "success", // success | danger
});

  const playheadRef = useRef(null);
const timelineRef = useRef(null);
const isDraggingRef = useRef(false);
const wasPlayingRef = useRef(false);
const [menu, setMenu] = useState({
  visible: false,
  x: 0,
  y: 0,
  time: 0
});
const [textModal, setTextModal] = useState({
  open: false,
  time: 0,
  text: ""
});

const showToast = (message, variant = "success") => {
  setToast({ show: true, message, variant });
  setTimeout(() => {
    setToast({ show: false, message: "", variant });
  }, 2500);
};
//const descriptions = window.__DESCRIPTIONS__ || []; 
const descriptions = video?.descriptions || [];

// OR pass as prop: const descriptions = props.descriptions;

const isOverlappingAdd = (start, end) => {
  const startSec = hhmmssToSeconds(start);
  const endSec = hhmmssToSeconds(end);

  return descriptions.some((d) => {
    const s = hhmmssToSeconds(d.start_time);
    const e = hhmmssToSeconds(d.end_time);
    return startSec < e && endSec > s;
  });
};

  /* 🔗 SYNC WITH MAIN VIDEO */
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const onLoaded = () => setDuration(video.duration || 0);

    const onTimeUpdate = () => {
      setCurrentTime(video.currentTime);
      setPlayheadPercent(
        video.duration ? (video.currentTime / video.duration) * 100 : 0
      );
    };

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);

    video.addEventListener("loadedmetadata", onLoaded);
    video.addEventListener("timeupdate", onTimeUpdate);
    video.addEventListener("play", onPlay);
    video.addEventListener("pause", onPause);

    return () => {
      video.removeEventListener("loadedmetadata", onLoaded);
      video.removeEventListener("timeupdate", onTimeUpdate);
      video.removeEventListener("play", onPlay);
      video.removeEventListener("pause", onPause);
    };
  }, [videoRef]);


useEffect(() => {
  const onMouseMove = (e) => {
    if (!isDraggingRef.current || !videoRef.current) return;

    const rect = timelineRef.current.getBoundingClientRect();
    let x = e.clientX - rect.left;
    x = Math.max(0, Math.min(x, rect.width));

    const percent = x / rect.width;
    videoRef.current.currentTime = percent * duration;
  };

  const onMouseUp = () => {
    if (!isDraggingRef.current) return;

    isDraggingRef.current = false;

    // ▶️ resume play ONLY if it was playing
    if (wasPlayingRef.current) {
      videoRef.current.play();
    }
  };

  window.addEventListener("mousemove", onMouseMove);
  window.addEventListener("mouseup", onMouseUp);

  return () => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
  };
}, [duration, videoRef]);
const secondsToHHMMSS = (sec) => {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = Math.floor(sec % 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

const hhmmssToSeconds = (ts) => {
  const [h, m, s] = ts.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};

const onPlayheadMouseDown = (e) => {
  e.stopPropagation();

  const video = videoRef.current;
  if (!video) return;

  // remember state
  wasPlayingRef.current = !video.paused;

  // pause immediately (VEED behaviour)
  video.pause();

  isDraggingRef.current = true;
};



  /* ▶️ PLAY / PAUSE */
  const togglePlayPause = () => {
    const v = videoRef.current;
    if (!v) return;
    v.paused ? v.play() : v.pause();
  };

  /* 🖱️ SEEK */
  const handleTimelineClick = (e) => {
    const video = videoRef.current;
    if (!video || !duration) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    video.currentTime = percent * duration;
  };

  /* 🎞️ FRAME THUMBNAILS */
 useEffect(() => {
  if (!videoRef.current || !timelineCanvasRef.current) return;

  const sourceVideo = videoRef.current;
  const thumbVideo = sourceVideo.cloneNode(true);
  const canvas = timelineCanvasRef.current;
  const ctx = canvas.getContext("2d");

  const THUMB_W = 70;
  const THUMB_H = 40;

  thumbVideo.muted = true;
  thumbVideo.preload = "auto";

  thumbVideo.onloadedmetadata = async () => {
    const dur = thumbVideo.duration;

    // const MIN_FRAMES = 6;
    // const MAX_FRAMES = 24;

    // let frames = Math.round(dur / 2);
    // frames = Math.min(Math.max(frames, MIN_FRAMES), MAX_FRAMES);
const MIN_FRAMES = 3;
const MAX_FRAMES = 6;

let frames = Math.round(dur / 10); // bigger divisor → fewer frames
frames = Math.min(Math.max(frames, MIN_FRAMES), MAX_FRAMES);

    // canvas.width = frames * THUMB_W;
    const timelineWidth = timelineRef.current.offsetWidth;
// canvas.width = timelineWidth;
canvas.width = timelineRef.current.offsetWidth;
    canvas.height = THUMB_H;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let i = 0; i < frames; i++) {
      thumbVideo.currentTime = (dur / frames) * i;
      await new Promise((r) => (thumbVideo.onseeked = r));
      // ctx.drawImage(thumbVideo, i * THUMB_W, 0, THUMB_W, THUMB_H);
//       const segmentWidth = canvas.width / frames;
// ctx.drawImage(thumbVideo, i * segmentWidth, 0, segmentWidth, THUMB_H);
const segmentWidth = canvas.width / frames;

ctx.drawImage(
  thumbVideo,
  i * segmentWidth,
  0,
  segmentWidth, // fill full segment
  THUMB_H
);

    }
  };

  thumbVideo.src = videoSrc;
}, [videoSrc, videoRef]);

  const formatClock = (s) => {
    const m = Math.floor(s / 60);
    const sec = (s % 60).toFixed(1);
    return `${String(m).padStart(2, "0")}:${String(sec).padStart(4, "0")}`;
  };

const formatTimeMMSS = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};


useEffect(() => {
  const hide = () => setMenu((m) => ({ ...m, visible: false }));
  window.addEventListener("click", hide);
  return () => window.removeEventListener("click", hide);
}, []);

const handleSaveNewDescription = async () => {
  const startSec = hhmmssToSeconds(addStart);
  const endSec = hhmmssToSeconds(addEnd);

  if (!addText.trim()) {
    showToast("Description is required", "danger");
    return;
  }

  if (isNaN(startSec) || isNaN(endSec) || endSec <= startSec) {
    showToast("Invalid time interval", "danger");
    return;
  }

  if (isOverlappingAdd(addStart, addEnd)) {
    showToast("This time overlaps with another description", "danger");
    return;
  }

  try {
    setIsAdding(true);

    const res = await fetch("/api/add-description", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        start_time: addStart,
        end_time: addEnd,
        caption: addText,
      }),
    });

    if (!res.ok) throw new Error("Failed");

    showToast("Description added successfully", "success");
    setShowAddModal(false);

    setTimeout(() => window.location.reload(), 800);
  } catch (err) {
    console.error(err);
    showToast("Failed to add description", "danger");
  } finally {
    setIsAdding(false);
  }
};

const timeToPercent = (hhmmss) => {
  if (!duration) return 0;
  const sec = hhmmssToSeconds(hhmmss);
  return (sec / duration) * 100;
};

// const handleSaveNewDescription = async () => {
//   const startSec = hhmmssToSeconds(addStart);
//   const endSec = hhmmssToSeconds(addEnd);

//   if (!addText.trim()) return alert("Description required");
//   if (isNaN(startSec) || isNaN(endSec) || endSec <= startSec) {
//     return alert("Invalid time interval");
//   }

//   try {
//     setIsAdding(true);

//     const res = await fetch("/api/add-description", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         start_time: addStart,
//         end_time: addEnd,
//         caption: addText,
//       }),
//     });

//     if (!res.ok) throw new Error("Failed");

//     setShowAddModal(false);

//     setTimeout(() => {
//       window.location.reload();
//     }, 600);

//   } catch (err) {
//     console.error(err);
//     alert("Failed to add description");
//   } finally {
//     setIsAdding(false);
//   }
// };
const INTERVAL_COUNT = 6;
const INTERVAL = duration / INTERVAL_COUNT;

return (
    <div className="timeline-preview-container">

      {/* ▶️ CONTROLS */}
      <div className="timeline-header">
        <div className="timeline-controls">
          <button onClick={() => (videoRef.current.currentTime -= 5)}>⏮️</button>
          <button onClick={togglePlayPause}>
            {isPlaying ? "⏸️" : "▶️"}
          </button>
          <button onClick={() => (videoRef.current.currentTime += 5)}>⏭️</button>
        </div>

        <div className="timeline-time">
          {formatClock(currentTime)} / {formatClock(duration)}
        </div>
      </div>
{/* ⏱️ TIME INTERVAL RULER */}
<div className="timeline-ruler">
  {/* {Array.from({ length: Math.ceil(duration / 4) + 1 }).map((_, i) => {
    const time = i * 4; */}

{Array.from({ length: INTERVAL_COUNT + 1 }).map((_, i) => {
  const time = i * INTERVAL;
    return (
      <div
        key={i}
        className="timeline-ruler-tick"
        style={{ left: `${(time / duration) * 100}%` }}
      >
        {/* <span>{time === 0 ? "0s" : `${time}s`}</span> */}
        <span>{formatTimeMMSS(time)}</span>

      </div>
    );
  })}
</div>

      

{/* <div
  className="timeline-strip-wrapper"
  ref={timelineRef}
  onClick={handleTimelineClick}
> */}

<div
  className="timeline-strip-wrapper position-relative"
  ref={timelineRef}
  onClick={handleTimelineClick}
>

  {/* 🔥 EXISTING INTERVAL MARKS */}
  <div className="timeline-interval-layer">
    {descriptions.map((d, i) => {
      const left = timeToPercent(d.start_time);
      const right = timeToPercent(d.end_time);
      const width = right - left;

      return (
        <div
          key={i}
          className="timeline-interval"
          style={{
            left: `${left}%`,
            width: `${width}%`,
          }}
          title={`${d.start_time} - ${d.end_time}`}
        />
      );
    })}
  </div>

  <div
    ref={playheadRef}
    className="playhead"
    style={{ left: `${playheadPercent}%` }}
    onMouseDown={onPlayheadMouseDown}
    onContextMenu={(e) => {
    e.preventDefault();

    setMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      time: currentTime
    });
  }}
  />


  <canvas ref={timelineCanvasRef} className="timeline-canvas" />
</div>


{menu.visible && (
  <div
    className="context-menu"
    style={{ top: menu.y, left: menu.x }}
    onClick={(e) => e.stopPropagation()}
  >
  
{/* <button
  onClick={() => {
    const start = secondsToHHMMSS(menu.time);
    const end = secondsToHHMMSS(menu.time + 2); // default 2s

    setAddStart(start);
    setAddEnd(end);
    setAddText("");

    setShowAddModal(true);
    setMenu({ ...menu, visible: false });
  }}
>
  ➕ Add Description
</button> */}

{/* 
    <button onClick={() => setMenu({ ...menu, visible: false })}>
      ❌ Cancel
    </button> */}
  </div>
)}

{textModal.open && (
  <div className="modal-overlay">
    <div className="modal-box">
      <h4>Add Description</h4>

      <div className="modal-time">
        Time: <b>{textModal.time.toFixed(2)}s</b>
      </div>

      <textarea
        placeholder="Enter Description..."
        value={textModal.text}
        onChange={(e) =>
          setTextModal({ ...textModal, text: e.target.value })
        }
      />

      <div className="modal-actions">
        <button
          className="btn-cancel"
          onClick={() => setTextModal({ open: false })}
        >
          Cancel
        </button>

        <button
          className="btn-save"
          onClick={async () => {
            if (!textModal.text.trim()) return;

            await fetch("/add-description", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                time: textModal.time,
                text: textModal.text
              })
            });

            setTextModal({ open: false });

            // refresh after success
            window.location.reload();
          }}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}


{showAddModal && (
  <div className="modal fade show d-block" tabIndex="-1" role="dialog">
    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Add Description</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowAddModal(false)}
          />
        </div>

        <div className="modal-body">

          <div className="mb-3">
            <label className="form-label">Start Time (HH:MM:SS)</label>
            <input
              type="text"
              className="form-control"
              value={addStart}
              onChange={(e) => setAddStart(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">End Time (HH:MM:SS)</label>
            <input
              type="text"
              className="form-control"
              value={addEnd}
              onChange={(e) => setAddEnd(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Description Text</label>
            <textarea
              rows="4"
              className="form-control"
              value={addText}
              onChange={(e) => setAddText(e.target.value)}
            />
          </div>

        </div>

        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={() => setShowAddModal(false)}
            disabled={isAdding}
          >
            Cancel
          </button>

          <button
            className="btn btn-primary"
            onClick={handleSaveNewDescription}
            disabled={isAdding}
          >
            {isAdding ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Saving...
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>

      </div>
    </div>
  </div>
)}
{toast.show && (
  <>
    {/* Dark overlay */}
    <div
      className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
      style={{ zIndex: 1055 }}
    />

    {/* Centered Toast */}
    <div
      className="position-fixed top-50 start-50 translate-middle"
      style={{ zIndex: 1060 }}
    >
      <div className={`toast show text-bg-${toast.variant} shadow-lg`}>
        <div className="d-flex align-items-center">
          <div className="toast-body px-4 py-3 fs-6">
            {toast.message}
          </div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            onClick={() => setToast({ ...toast, show: false })}
          />
        </div>
      </div>
    </div>
  </>
)}

    </div>
  );
};

export default AudioDescriptionEdit;
